/**
 * Fenêtre de rappel web (carte « ⏰ Rappel » de la cloche).
 *
 * - `webNotifiedAt` : première apparition de la carte, écrite une seule fois.
 * - `webDismissedAt` : carte fermée ; `null` explicite = affichée, pas encore
 *   traitée (elle revient après un rechargement).
 * Un rappel antérieur à ce découpage porte `webNotifiedAt` sans champ
 * `webDismissedAt` : il avait été fermé (l'ancienne écriture se faisait à la
 * fermeture) et ne doit pas se rouvrir. Replanifier remet les deux à `null`.
 */
export function isActivityWebAlertPending(activity) {
  if (!activity) return false;
  if (activity.webDismissedAt) return false;
  if (!activity.webNotifiedAt) return true;
  return activity.webDismissedAt === null;
}

export function isActivityWebAlertDue(activity, nowUnix) {
  return Boolean(
    activity &&
      activity.status === "open" &&
      activity.dueAtUnix &&
      activity.dueAtUnix <= nowUnix &&
      isActivityWebAlertPending(activity)
  );
}

export default isActivityWebAlertDue;
